var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiquity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 137,
    height: 33,
    viewBox: "0 0 137 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1421 25.9255H59.0226V22.8238H50.6648V5.45441H47.1421V25.9255Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2194 10.6583H61.8003V25.9255H65.2194V10.6583ZM63.5271 8.14253C64.6668 8.14253 65.6684 7.17756 65.6684 6.00582C65.6684 4.83407 64.6668 3.90356 63.5271 3.90356C62.3529 3.90356 61.3513 4.83407 61.3513 6.00582C61.3513 7.17756 62.3529 8.14253 63.5271 8.14253Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M82.752 11.451C81.1978 10.7962 79.0566 10.3137 76.9499 10.3137C71.5277 10.3137 68.1431 13.4154 68.1431 18.3092C68.1431 23.3752 71.5277 26.2701 76.4664 26.2701C77.6751 26.2701 78.7803 26.0289 79.3674 25.7877V32.1289H82.752V11.451ZM79.3674 22.8238C78.504 23.134 77.7787 23.3063 76.6736 23.3063C73.5999 23.3063 71.5968 21.3419 71.5968 18.3092C71.5968 15.1385 73.6344 13.3465 76.9499 13.3465C77.8824 13.3465 78.6767 13.5188 79.3674 13.7256V22.8238Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.1913 10.6583H95.8067V23.2374C94.9088 23.3752 93.9418 23.4442 93.182 23.4442C90.9371 23.4442 89.5557 22.6171 89.5557 20.3425V10.6583H86.1711V20.5837C86.1711 24.8572 88.865 26.2701 93.2511 26.2701C95.0469 26.2701 97.3954 26.0289 99.1913 25.5809V10.6583Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.992 10.6583H103.573V25.9255H106.992V10.6583ZM105.3 8.14253C106.44 8.14253 107.441 7.17756 107.441 6.00582C107.441 4.83407 106.44 3.90356 105.3 3.90356C104.126 3.90356 103.124 4.83407 103.124 6.00582C103.124 7.17756 104.126 8.14253 105.3 8.14253Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M109.584 13.5188H111.898V21.5487C111.898 25.0295 114.005 26.2701 116.491 26.2701C117.942 26.2701 119.185 25.96 120.187 25.443V22.3758C119.254 22.9272 118.391 23.2374 117.389 23.2374C116.077 23.2374 115.283 22.6171 115.283 20.7905V13.5188H119.634V10.6583H115.283V6.93632H111.898V10.6583H109.584V13.5188Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.466 10.6583H120.805L127.125 26.6148L124.984 32.1289H128.334L136.622 10.6583H133.1L128.817 22.686L124.466 10.6583Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.091,
    cy: 16.0644,
    r: 16.0644,
    fill: "#2EB6EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0041 32.1287C0.0269385 32.1287 -6.27875 11.1099 7.83384 2.25195C6.15552 19.8194 15.0835 20.208 23.3684 19.8194C37.251 19.1683 37.2603 32.1287 37.2603 32.1287H16.0041Z",
    fill: "#1542CD"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.2764 21.3196C28.8593 27.5143 22.9155 31.9439 15.9128 32.1407C16.0777 32.1453 16.2437 32.1476 16.4107 32.1476H37.5334C37.5334 32.1476 37.528 24.5512 31.2764 21.3196Z",
    fill: "#745DDF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiquity);
export default __webpack_public_path__ + "static/media/liquity.af07dc86f237a234e7d462564d050ca4.svg";
export { ForwardRef as ReactComponent };